/*
 * Breakpoints:
 * xs: 640 - 1
 * sm: 768 - 1
 * md: 1024 - 1
 * lg: 1280 - 1
 * xl: 1750 - 1
 * 2xl and higher: 9999
 */

// Swiper's `breakpoints` are keyed by min-width ("at this width and up"), unlike Glide's max-width keys
// ("up to this width") used before the Swiper migration. `slidesPerView` below each preset's base value
// is the count below the first breakpoint.
const breakpointsList = {
  // mx1: max 1 item on all breakpoints
  mx1: {},
  // mx2: max 2 items on widest breakpoints
  mx2: {
    1024: { slidesPerView: 2 },
  },
  // mx3: max 3 items on widest breakpoints
  mx3: {
    640: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
  },
  // mx4: max 4 items on widest breakpoints
  mx4: {
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 3 },
    1280: { slidesPerView: 4 },
  },
}

export default breakpointsList
